(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory(require("canvas"), require("fs"));
	else if(typeof define === 'function' && define.amd)
		define(["canvas", "fs"], factory);
	else if(typeof exports === 'object')
		exports["bfontjs"] = factory(require("canvas"), require("fs"));
	else
		root["bfontjs"] = factory(root["canvas"], root["fs"]);
})(self, (__WEBPACK_EXTERNAL_MODULE__517__, __WEBPACK_EXTERNAL_MODULE__89__) => {
return 